











































































import cartGetters from '~/modules/checkout/getters/cartGetters';
import { useCartView } from '~/modules/checkout/composables/useCartView';
import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { useImage, CartItemInterface, useUser } from '~/composables';
import ImageWrapper from '~/components/image/ImageWrapper.vue';

export default defineComponent({
  name: 'SummaryProducts',
  components: {
    SectionHeading: () => import(/* webpackPrefetch: true */ '~/modules/checkout/components/SectionHeading.vue'),
    ImageWrapper,
  },
  props: {
    products: {
      type: Array as PropType<CartItemInterface[]>,
      required: true,
    },
  },
  setup() {
    const { isB2bUser } = useUser();
    const { getMagentoImage, baseImageConfig } = useImage();
    const { getAttributes } = useCartView();
    return {
      getAttributes,
      cartGetters,
      getMagentoImage,
      baseImageConfig,
      isB2bUser,
    };
  },
});
